import { ErrorMessage, Field, Form, Formik } from "formik";
import "moment-timezone";
import React, { Component } from "react";
import { Button, Checkbox, ControlLabel } from "react-bootstrap";
import InputMask from "react-input-mask";
import Alert from 'react-s-alert';
import * as Yup from "yup";
import FormikFormControl from '../Shared/Forms/FormikFormControl';
import ContactsService from '../utils/ContactsService';





class EditContactForm extends Component {
  state = {
    serverErrors: {}
  }

  render() {
    const validationSchema = Yup.object().shape({
      contact_type: Yup.string()
        .required(),
      region: Yup.string()
        .required(),
      first_name: Yup.string()
        .max(30, "maximum 30 characters"),
      last_name: Yup.string()
        .max(30, "maximum 30 characters"),
      email: Yup.string()
        .max(100, "maximum 100 characters")
        .email("doesn't look like a valid email address"),
      mobile: Yup.string()
        .notRequired()
        .matches(/04\d\d \d\d\d \d\d\d/, "must be an Australian mobile number")
    });

    const { contact, onCancelSubmit } = this.props

    return (
      <div>
        {contact ? (
          <div>
            <Formik
              initialValues={{
                deal_id: contact.deal_id,
                email: contact.email || "",
                region: contact.region || "",
                first_name: contact.first_name || "",
                last_name: contact.last_name || "",
                mobile: contact.mobile || "",
                quicknotes: contact.quicknotes || "",
                contact_type: contact.contact_type || 'PARENT',
                bad_number: contact.bad_number,
                unsubscribed_number: contact.unsubscribed_number
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting, setErrors }) => {
                setSubmitting(true);
                this.serverErrors = {}
                const { onSubmit } = this.props

                const save = contact.id ? ContactsService.update(contact.id, values) : ContactsService.create(values)
                save.then(data => {
                  Alert.success('Updated')
                  onSubmit(data)
                  setSubmitting(false);
                }).catch(error => {
                  let errors = {};
                  Object.keys(error.data).map(
                    key => (errors[key] = error.data[key].join(", "))
                  );
                  setErrors(errors);
                  setSubmitting(false);
                });
                // .catch(response => {
                //   setSubmitting(false);
                //   if (response.status === 422) this.setState({ serverErrors: response.data })
                // });
              }}
              render={({
                errors,
                touched,
                isSubmitting,
                values,
                setFieldValue,
                setFieldTouched, isValid
              }) => {
                const { serverErrors } = this.state
                const hasError = (key) => {
                  return ((errors[key] && touched[key]) || serverErrors[key]) && "has-error"
                }

                return (
                  <Form>
                    <p><small>Many automated processes use these values, please ensure your changes are correct. If you change the email address a new contact in LeadMachine will be used, and old information will remain on the old contact</small></p>

                    <div className='row'>
                      <div className='col-md-6'>
                        <FormikFormControl fieldName='contact_type' errors={errors} touched={touched}>
                          <ControlLabel>Contact Type</ControlLabel>
                          <Field className="form-control input-sm" name="contact_type" component="select">
                            <option value='PARENT'>PARENT</option>
                            <option value='STUDENT'>STUDENT</option>
                          </Field>
                        </FormikFormControl>

                      </div>
                      <div className='col-md-6'>
                        <FormikFormControl fieldName='region' errors={errors} touched={touched}>
                          <ControlLabel>Region</ControlLabel>
                          <Field component="select" name="region" className="form-control">
                            <option value=''>-- select --</option>
                            <option value="ACT">Australian Capital Territory (SSC)</option>
                            <option value="NSW">New South Wales (HSC)</option>
                            <option value="NT">Northern Territory (NTCET)</option>
                            <option value="QLD">Queensland (QCE)</option>
                            <option value="SA">South Australia (SACE)</option>
                            <option value="TAS">Tasmania (TCE)</option>
                            <option value="VIC">Victoria (VCE)</option>
                            <option value="WA">Western Australia (WACE)</option>
                          </Field>
                        </FormikFormControl>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-6'>
                        <div className={`form-group ${hasError('mobile')}`} >
                          <ControlLabel>Mobile</ControlLabel>
                          <Field type="text" name="mobile" className="form-control"
                            render={({ field }) => {
                              return (
                                <InputMask
                                  mask="9999 999 999"
                                  {...field}
                                  className="form-control"
                                  placeholder="Mobile number"
                                />
                              );
                            }}
                          />
                          {serverErrors.mobile && <p className='help-block'>{serverErrors.mobile.join(', ')}</p>}
                          <ErrorMessage name="mobile" component="span" className="help-block" />
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className={`form-group ${hasError('email')}`} >
                          <ControlLabel>Email</ControlLabel>
                          <Field type="text" name="email" className="form-control" />
                          {serverErrors.email && <p className='help-block'>{serverErrors.email.join(', ')}</p>}
                          <ErrorMessage name="email" component="span" className="help-block" />
                        </div>

                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-md-6'>
                        <div className={`form-group ${hasError('first_name')}`} >
                          <ControlLabel>First Name</ControlLabel>
                          <Field type="text" name="first_name" className="form-control" />
                          {serverErrors.first_name && <p className='help-block'>{serverErrors.first_name.join(', ')}</p>}
                          <ErrorMessage name="first_name" component="span" className="help-block" />
                        </div>

                      </div>
                      <div className='col-md-6'>
                        <div className={`form-group ${hasError('last_name')}`} >
                          <ControlLabel>Last Name</ControlLabel>
                          <Field type="text" name="last_name" className="form-control" />
                          {serverErrors.last_name && <p className='help-block'>{serverErrors.last_name.join(', ')}</p>}
                          <ErrorMessage name="last_name" component="span" className="help-block" />
                        </div>

                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-md-12'>
                        <div className={`form-group ${hasError('quicknotes')}`} >
                          <ControlLabel>Quick Notes</ControlLabel>
                          <Field component="textarea" name="quicknotes" className="form-control" />
                          <ErrorMessage name="quicknotes" component="span" className="help-block" />
                        </div>

                      </div>
                    </div>

                    <Checkbox checked={values.bad_number} onChange={(e) => { setFieldValue('bad_number', e.target.checked) }}>Bad Number?</Checkbox>
                    <Checkbox checked={values.unsubscribed_number} onChange={(e) => { setFieldValue('unsubscribed_number', e.target.checked) }}>Unsubscribed?</Checkbox>


                    <div style={{ marginTop: "20px" }}>
                      {onCancelSubmit && <Button onClick={onCancelSubmit} bsSize='small'>Whoops, cancel this</Button>}
                      <Button className='pull-right' disabled={!isValid || isSubmitting} type="submit" bsStyle='danger' bsSize='small'>Go ahead and Update</Button>
                    </div>

                  </Form>
                )
              }}
            />
          </div>
        ) : (
            <div />
          )}
      </div>
    );
  }
}
export default EditContactForm;
